import { useMediaQuery } from '../useMediaQuery';

export const useIsSmallMobile = () => useMediaQuery('(max-width: 359.98px)');
